/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import ComponentMap from '../../atom/componentMap'
import classes from './customize.module.scss';
import cx from 'classnames';
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';
import CloseIcon from '@mui/icons-material/Close';
import moment from "moment";
import showMessage from "./Common/notification";
import { SUBMIT_REQUEST } from "../../graphQL/mutations";
import thankyou from '../../asset/frames/thankyou.png';
import errorimg from '../../asset/frames/error.png';
import { useMutation } from "@apollo/client";
import PopupCalander from "../../atom/popupCalender";
import { v4 as uuidv4 } from 'uuid';
import { FavouriteSvg, SelectedFavouriteSvg } from "../../constants/resources";

const CustomizeForMe = (props: any) => {
    const { buliddata, Itinerarydata, fav, favApi } = props;
    const [activeNode, setActiveNode] = useState(false);
    const [dayFlex, setDayFlex] = useState(false);
    const [toggleHover, setToggleHover] = useState(false);
    const [success, setSuccess] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(false);
    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(Itinerarydata.startDate ? Itinerarydata.startDate : null),
        endDate: new Date(Itinerarydata.startDate ? Itinerarydata.startDate : null),
    });


    const [data, setData] = useState<any>([])


    const [SendData] = useMutation(SUBMIT_REQUEST, {
        onError: (error) => {

        }
    })


    const handleFlag = () => {
        setToggleHover(false)
        setActiveNode(!activeNode)
        setDayFlex(false)
    }


    useEffect(() => {
        setData([{
            name: 'name',
            title: 'name',
            value: '',
            hidden: true
        },
        {
            name: 'key',
            title: 'key',
            value: '',
            hidden: true
        },
        {
            name: 'firstname',
            title: 'First name',
            value: '',
            placeholder: 'Write your first name',
            required: true,
            errormessage: 'Please enter First Name'
        },
        {
            name: 'lastname',
            title: 'Last name',
            value: '',
            placeholder: 'Write your last name',
            required: true,
            errormessage: 'Please enter First Name'
        },
        {
            name: 'email',
            title: 'Email address',
            type: 'email',
            value: '',
            placeholder: 'Write your email address',
            required: true,
            errormessage: 'Please enter First Name'
        }, {
            name: 'phone',
            title: 'Number',
            value: '',
            type: 'phone',
            placeholder: 'XXXXXXXXXXXX',
            required: true,
            errormessage: 'Please enter First Name'
        },
        {
            name: 'from',
            title: 'Departure Airport',
            value: '',
            placeholder: 'Write your airport of departure',
            required: true,
            errormessage: 'Please enter First Name'
        },
        {
            name: 'destination',
            title: 'Desired destination',
            value: Itinerarydata.destination,
            layout: 2,
            placeholder: 'Write your desired destination',
            errormessage: 'Please enter First Name',
            hidden: true

        }, {
            name: 'vacationType',
            title: 'Vacation Type',
            hidden: true,
            value: null,
            placeholder: '',
            type: 'VT',
            required: true,
            errormessage: 'Please select Vacation Type'
        },
        {
            name: 'roomInfo',
            title: 'roomInfo',
            value: [],
            hidden: true
        },
        {
            name: 'adultsCount',
            title: 'Adults',
            value: 1,
            type: 'adults'
        }, {
            name: 'kidsCount',
            title: 'Childrens',
            value: 0,
            type: 'adults',
            children: []
        },
        {
            name: 'startDate',
            title: 'Start date',
            value: Itinerarydata.startDate ? selectionRange.startDate : null,
            type: "calender",
            placeholder: 'Any date',

        },

        {
            name: 'endDate',
            title: 'End date',
            value: selectionRange.endDate,
            type: "calender",
            placeholder: 'Any date',
            hidden: true
        },
        {
            name: 'tripDateFelxibility',
            title: 'flex',
            value: 0,
            placeholder: 'Any date',
            type: "calender",
            hidden: true
        },
        {
            name: 'duration',
            title: 'Duration of the trip',
            value: moment.utc(Itinerarydata.endDate).diff(moment.utc(Itinerarydata.startDate), 'days'),
            type: 'add'

        },
        {
            name: 'budget',
            title: 'Budget',
            value: '',
            placeholder: '',
            type: 'budget'
        }, {
            name: 'questionType',
            title: 'questionType',
            value: 'CustomizeForMe',
            hidden: true
        }, {
            name: 'customFromItinerary',
            title: 'customFromItinerary',
            value: { id: buliddata.id },
            placeholder: '',
            hidden: true
        },
        {
            name: 'submitTime',
            title: 'submitTime',
            value: new Date(),
            hidden: true
        },
        {
            name: 'roomRequirement',
            title: 'roomRequirement',
            value: Itinerarydata.roomRequirement,
            hidden: true
        },
        {
            name: 'resortRquirements',
            title: 'resortRquirements',
            value: Itinerarydata.resortRquirements,
            hidden: true
        },
        {
            name: 'previouslyStayedResortInfo',
            title: 'previouslyStayedResortInfo',
            value: Itinerarydata.previouslyStayedResortInfo,
            hidden: true
        },
        {
            name: 'interests',
            title: 'interests',
            value: Itinerarydata.interests,
            hidden: true
        },
        {
            name: 'bookingItems',
            title: 'bookingItems',
            value: Itinerarydata.bookingItems,
            hidden: true
        },
        {
            name: 'importantInfo',
            title: 'importantInfo',
            value: Itinerarydata.importantInfo,
            hidden: true
        },
        {
            name: 'cities',
            title: 'cities',
            value: Itinerarydata.cities,
            hidden: true
        },
        {
            name: 'attractions',
            title: 'attractions',
            value: Itinerarydata.attractions,
            hidden: true
        },
        {
            name: 'summary',
            title: 'summary',
            value: '',
            hidden: true
        },
        {
            name: 'tours',
            title: 'tours',
            value: Itinerarydata.tours,
            hidden: true
        },
        {
            name: 'stayRequirements',
            title: 'stayRequirements',
            value: Itinerarydata.stayRequirements,
            hidden: true
        },
        {
            name: 'amenities',
            title: 'amenities',
            value: Itinerarydata.amenities,
            hidden: true
        },
        {
            name: 'vacationType',
            title: 'vacationType',
            value: Itinerarydata.vacationType,
            hidden: true
        },
        {
            name: 'comment',
            title: 'Please provide additional comments on how you would like to custozime this Itinerary? e.g accommodation preferences, interests, etc.',
            value: '',
            placeholder: 'Write your comment'
        }
        ])
        setSuccess(false)
        setSubmitStatus(false)
    }, [activeNode])

    const calcDate = async () => {
        let updateData = [...data];
        let date: any = selectionRange.endDate;
        var result = data.find((obj: any) => {
            return obj.type === 'add'
        })
        updateData.map((node: any) => {

            if (node.name === 'endDate') {
                date = moment.utc(selectionRange.startDate).add(result.value, 'days')
            }

            return node.name === 'startDate' ?
                node.value = new Date(selectionRange.startDate).toDateString() :
                node.name === 'endDate' ? node.value = new Date(date ? date : selectionRange.endDate).toDateString() : null
        })
        await setData([...updateData])
    }
    const SendRequest = async () => {
        await calcDate();
        let flag = true;
        let variables: any = {};
        let errormessage = '';
        let adultsCount: any;
        let childrensCount: any;
        let ChildrenAges = '';
        // data.map((node: any) => {
        for (let i = 0; i < data.length; i++) {
            let node: any = data[i];
            if (node.required && node.required === true && (node.value === '' || node.value === undefined)) {
                errormessage = (errormessage === '') ? node.title : errormessage + ',<br/>' + node.title;
                flag = false;
                // break;
            }

            let value = node.value;

            if (node.type === 'calender') {
                if (node.name === 'startDate') {
                    variables[node.name] = moment.utc(node.value).format('YYYY-MM-DDT00:00:00.000').toString();


                }

            }
            if (node.type === 'phone' && node.value !== '') {
                let value = node.value;
                if (value.length > 10) {
                    node.value = value;
                }
                else {
                    errormessage = (errormessage === '')
                        ? "Please enter a valid Phone Number"
                        : `${errormessage},<br/>Please enter a valid Phone Number`;

                    flag = false;
                    // break;
                }
            }
            if (node.type === 'email' && node.value !== '') {
                let value = node.value;
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(value)) {
                    node.value = value;
                }
                else {
                    errormessage = (errormessage === '')
                        ? "Please enter correct Email"
                        : `${errormessage},<br/>Please enter correct Email`;

                    flag = false;
                }
            }

            if (node.name === 'key' && node.value === '') {
                value = uuidv4();
                variables['key'] = value
            }
            if (node.name === 'name') {
                variables['name'] = '';
            } else if (node.name === 'firstname') {
                variables['name'] = value;
            } else if (node.name === 'lastname') {
                variables['name'] += " " + value;
            } else if (node.name === 'roomInfo') {
                variables['roomInfo'] = [{
                    number: 1,
                    adults: 1,
                    children: 0,
                    childrenAge: []
                }];


            } else if (node.name === 'adultsCount') {
                adultsCount = node.value;
                variables[node.name] = node.value;
                variables['roomInfo'][0].adults = node.value;

            } else if (node.name === 'kidsCount') {
                childrensCount = node.value;
                variables[node.name] = node.value;
                var chi: any = [];
                // eslint-disable-next-line no-loop-func
                await node.children.map((nn: any) => {
                    if (ChildrenAges !== '') {
                        ChildrenAges += ', ';
                    }
                    ChildrenAges += nn.value.toString();
                    return chi.push(nn.value)
                }

                )
                variables['roomInfo'][0].children = node.value;
                variables['roomInfo'][0].childrenAge = chi;

            }

            else {
                variables[node.name] = value;
            }

        }

        if (flag) {

            var summary = `${variables["name"] ? variables["name"] : ''}, You are going to the ${variables["destination"] ? variables["destination"] : ''}
            from ${variables["from"] ? variables["from"] : ''}, during the dates from ${variables["startDate"] ? variables["startDate"] : ''} to ${variables["endDate"] ? variables["endDate"] : ''}.
            You are going to travel in a group of ${childrensCount + adultsCount} people:
            ${adultsCount} Adult${adultsCount > 1 ? 's' : ''}:${childrensCount} Children${childrensCount > 1 ? 's' : ''}
            ${childrensCount > 0 ? 'of age ' + ChildrenAges : null}.
            Your total trip budget is up to ${variables["budget"] ? variables["budget"] : ''}
            
            Your email id is ${variables["email"] ? variables["email"] : ''} and your Phone Number is ${variables["phone"] ? variables["phone"] : ''}`;

            variables['summary'] = summary;

            setTimeout(() => {
                SendData({
                    variables: variables
                }).then((response: any) => {
                    if (response.errors === undefined) {
                        setSuccess(true)
                        showMessage("Added Sucessfully", 'Your Request has been sent sucessfully', "success")
                    } else {
                        setSuccess(false)
                        showMessage("Error!", 'Please try again later', "danger")
                    }

                }).finally(() => {
                    setSubmitStatus(true)

                })
            }, 200);
        }
        else {
            showMessage("Fields are missing", errormessage, "danger")
            // alert("misiing")
            // showMessage('Something Went Wrong', `Please Enter All Fields`, "danger")
        }
    }

    return (
        <div>
            {activeNode ?

                <div className={classes.popbackg} >

                    <div className={cx(classes.customizeforme, activeNode ? classes.mobileListView : classes.mobileListHide)} >
                        <div className={classes.close}>
                            <HorizontalRuleOutlinedIcon onClick={() => setActiveNode(!activeNode)} />
                        </div>
                        <div className={classes.customizeForm}>
                            <span className={classes.close}>
                                <CloseIcon onClick={() => setActiveNode(!activeNode)} />
                            </span>
                            {submitStatus ? null : "Please fill out the information"}
                        </div>
                        {toggleHover ?
                            <div onClick={() => setToggleHover(false)} className={classes.CustomModal}>
                                <div className={classes.CustomCalendar}>

                                    <PopupCalander data={data} change={setData} setSelectionRange={setSelectionRange} setToggleHover={setToggleHover} selectionRange={selectionRange} />

                                </div>
                            </div>

                            : null}
                        <div className={classes.CustomiseArea}>
                            {submitStatus ?
                                success ?
                                    <div className="thankscenter">
                                        <img className="thanksImg" src={thankyou} alt="pic"></img>
                                        <div className="thanks">Congratulation!</div>
                                        <div className="thanksinfo">Your trip details have been successfully submitted </div>
                                    </div> : <div className="thankscenter">
                                        <img className="thanksImg" src={errorimg} alt="pic"></img>
                                        <div className="thanks">Error!</div>
                                        <div className="thanksinfo">Please try again later.</div>
                                    </div> : <div>{data.filter((node: any) => {
                                        return node.hidden !== true
                                    }).map((node: any, key: any) => {
                                        return <ComponentMap key={key} node={node} data={data} dayFlex={dayFlex} change={setData} toggleHover={toggleHover} setToggleHover={setToggleHover} setDayFlex={setDayFlex} setSelectionRange={setSelectionRange} selectionRange={selectionRange} />
                                    })}
                                    <div className={classes.buttonSet}>
                                        <button className={classes.sendButton} onClick={() => SendRequest()}>Send</button>
                                    </div>
                                </div>}

                        </div>

                    </div>

                </div>
                : null}



            <div className={classes.Customize}>

                <div style={{ minWidth: "370px", maxWidth: "380px", margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>

                    {!activeNode &&
                        <div className={classes.CustomizeButton} onClick={() => handleFlag()} >
                            Customize For Me
                        </div>}
                    <div onClick={() => favApi()} style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "0px 10px" }}>
                        {fav ? <SelectedFavouriteSvg />
                            : <FavouriteSvg />
                        }
                    </div>
                </div>

            </div>



        </div>
    )
}
export default CustomizeForMe